module.exports = __webpack_public_path__ + "media/fonts/Oricons-27e0bbfec1b948f799089187c60c76c0.woff2";